import React from 'react';

import { Popover, Button, Slider, Tooltip, Row, Col } from 'antd';

import { QuestionCircleOutlined } from '@ant-design/icons';

const AdvancedOptions = (props) => {
  return (
    // <Popover placement="bottomLeft" style={{ width: '500px' }} title={"Advanced Options"} content={(
      <Row>
       <Col span={24}>Smoothness <Slider defaultValue={1} min={0} max={1.34} step={0.01} onChange={(value) => { props.setSmoothness(value) }} /></Col> 
        <Col span={24}>Despeckle <Tooltip title="Remove small color blobs on the final image by increasing this slider."><QuestionCircleOutlined /></Tooltip><Slider defaultValue={props.despeckle} min={0} max={props.imageDimensions[0]/4 > 20 ? props.imageDimensions[0]/4:20} value={props.despeckle} step={1} onChange={(value) => { props.setDespeckle(value) }}  /></Col>
        <Col span={24}>Simplify Curves <Tooltip title="Increase how round and smooth curves appear with this slider."><QuestionCircleOutlined /> </Tooltip> <Slider defaultValue={0.2} min={0} max={1000} onChange={(value) => { props.setSimplifyCurves(value) }} step={0.01} /></Col>
      </Row>
    // )} trigger="click">
    //   <Button type="primary">Advanced Options</Button>
    // </Popover>
  );
};

export default AdvancedOptions;